import type {Exhibition} from "../../../../../../types/exhibition/types";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import * as React from "react";
import ImageFileUpload from "../../../../../../components/general/imageFileUpload/imageFileUpload";
import * as yup from "yup";
import {FormikProvider, useFormik} from "formik";
import Box from "@mui/material/Box";

type Props = {
    id: string,
    exhibition: Exhibition,
    updateExhibition: Function
}
const ImageByLanguage = (props: Props) => {
    const {id, language, exhibition, updateExhibition, updateType, name, updateProperty, label, onRemove = () => {}, displayLanguageOnLabel =true} = props
    const onChange = (value, type) => {
        if(type && type === 'remove') {
           onRemove(language)
        } else {
            updateExhibition(id, {file: value, language}, updateType)
        }
    }
    const validationSchema = yup.object({})
    const formik = useFormik({
        initialValues: {
            files: (
                exhibition[updateProperty] &&
                exhibition[updateProperty][language]
            ) ? [
                {
                    preview: exhibition[updateProperty][language],
                    name: name,
                }
            ] : []
        },
        validationSchema: validationSchema,
    })
    const onFileChange = (val, type) => {
        onChange(val, type)
    }
    return (
        <ListItem>
            <ListItemText
                primary={`${label} ${displayLanguageOnLabel ? language.toUpperCase() : ""}`}
                sx={{
                    color: 'text.main'
                }}
            />
            <FormikProvider value={formik}>
                <Box
                    sx={{
                        '& .MuiTextField-root': {my: 1},
                    }}
                    component="form"
                    onSubmit={formik.handleSubmit}
                >
                    <ImageFileUpload
                        files={formik.values.files}
                        accept={{
                            'image/jpeg': [],
                            'image/png': [],
                        }}
                        multiple={false}
                        onRemove={(val) => onFileChange(val, 'remove')}
                        onUpload={(val) => onFileChange(val, 'upload')}
                        onSelected={onFileChange}
                    />
                </Box>
            </FormikProvider>
        </ListItem>
    )
}

export default ImageByLanguage